import React, { PropsWithChildren } from "react";

import { Button } from "@/components/form/Button/Button";
import { Paper } from "@/components/paper/Paper";
import { InfoModalResDto } from "@/models/infoModalRes.dto";
import { clsxm } from "@/utils/tailwindMerge";

import { ModalCloseCross } from "../../components/ModalCloseCross";
import { useOpenModal } from "../../utils/openModal";

export const InfoModal = ({
  children,
  statusReg,
  onOkClick,
  headerName,
  disableonOkClickOnCross = false,
}: PropsWithChildren & {
  statusReg: InfoModalResDto["statusReg"];
  onOkClick?: () => void;
  disableonOkClickOnCross?: boolean;
  headerName?: string;
}) => {
  type StyleOptionsValues = { header: string; borderColor: string };

  const styleOptions: Record<InfoModalResDto["statusReg"], StyleOptionsValues> =
    {
      success: {
        borderColor: "border-green-600",
        header: headerName ? headerName : "Information!",
      },
      fail: { borderColor: "border-pink", header: "Ooops!" },
    };

  const borderColor = styleOptions[statusReg].borderColor;
  const header = styleOptions[statusReg].header;
  const { removeOne, removeAll } = useOpenModal();

  return (
    <Paper className={clsxm("p-6 mx-4 w-[265px] border-t-4", borderColor)}>
      <ModalCloseCross
        onClose={disableonOkClickOnCross ? removeAll : onOkClick || removeOne}
        className="-mt-3 -mr-3"
      />
      <Header>{header}</Header>
      {children}
    </Paper>
  );
};

const Header: React.FC<PropsWithChildren> = ({ children }) => {
  return <h2 className="text-lg font-bold -mt-4">{children}</h2>;
};
const Message: React.FC<PropsWithChildren> = ({ children }) => {
  return <p className="text-base">{children}</p>;
};

type InfoModalButtonProps = PropsWithChildren & {
  onClick: () => void;
};
const ButtonContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className="flex gap-2 mt-4">{children}</div>;
};

const InfoModalButton: React.FC<InfoModalButtonProps> = ({
  onClick,
  children,
}) => {
  return (
    <Button
      variant="primary"
      onHoverVariant="gradient-flip"
      className="w-full"
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

InfoModal.Button = InfoModalButton;
InfoModal.Message = Message;
InfoModal.ButtonContainer = ButtonContainer;
InfoModal.Header = Header;
